var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNextDayDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 69.723"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 32728"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 16",
    transform: "translate(0 6.723)",
    fill: "#fff",
    stroke: "#75b529",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 31.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 29,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 387",
    fill: "#fff",
    d: "M23 19.723h62v38H23z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 32726",
    fontSize: 15,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "NEXT DAY",
    transform: "translate(14 36.723)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NEXT DAY")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(14 51.723)",
    fill: "#8d8c8c"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DELIVERY"))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 548",
    d: "M49.987 5.78l4.25 13.6-14.24-.003",
    fill: "none",
    stroke: "#75b529",
    strokeLinecap: "round",
    strokeWidth: 5
  }))));
}

export default __webpack_public_path__ + "448cd490beb38c746a25c7055a08d24e.svg";
export { SvgNextDayDelivery as ReactComponent };